// ------------ ASSET IMPORTS ---------------
import "./Button.scss";
// ------------------------------------------
import React from 'react';
import LibButton from '@mui/material/Button';
import DotDotLoaderNew from 'common/ui/DotDotLoaderNew';
import PropTypes from 'prop-types';
import Icon from "../Icon";
import { Stack } from "@mui/material";

const VARIANTS = {
  primary: 'contained',
  secondary: 'text',
  link: 'link',
  outlined: 'outlined',
};

const SIZES = {
  small: 'small',
  large: 'large',
};

const Button = (props) => {
  const {
    size,
    isLoading,
    isInverted,
    variant,
    title,
    disabled,
    color,
    rightIconName,
    rightIconProps,
    backgroundColor,
    onClick,
    dataAid,
    onHoverStyle,
    children,
    ...restProps
  } = props;
  return (
    <LibButton
      isloading={isLoading ? 1 : 0}
      isinverted={isInverted ? 1 : 0}
      variant={VARIANTS[variant] || VARIANTS['primary']}
      size={SIZES[size] || SIZES['large']}
      color='secondary'
      disabled={disabled}
      onClick={onClick}
      data-aid={`button_${dataAid || variant}`}
      sx={{color, backgroundColor,':hover': onHoverStyle}}
      {...restProps}
    >
      {isLoading ? (
        <DotDotLoaderNew />
      ) : (
        <Stack
          className="button-content"
          flexDirection="row"
          alignItems="center"
        >
          <div data-aid="tv_title" className="button-text">
            {title || children}
          </div>
          {rightIconName && (
            <Icon
              dataAid="right"
              className="button-right-icon"
              size={16}
              name={rightIconName}
              {...rightIconProps}
            />
          )}
        </Stack>
      )}
    </LibButton>
  );
};

export default Button;

Button.defaultProps = {
  variant: 'primary',
  size: 'large',
  onHoverStyle: {},
  rightIconName: '',
  rightIconProps: {},
}

Button.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
  size: PropTypes.oneOf(['small', 'large']),
  title: PropTypes.string,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isInverted: PropTypes.bool,
  onClick: PropTypes.func,
};
